import React from 'react';
import { Link } from 'react-router-dom';
import { competitors, getRouteMetadata } from '../utils/seoMetadata.js';
import './Blog.css';

const alternatives = [
  { slug: 'trustpilot', name: 'Trustpilot', path: '/trustpilot-alternatives' },
  ...competitors.map((competitor) => ({
    ...competitor,
    path: `/alternatives/${competitor.slug}`
  }))
];

function Alternatives() {
  const metadata = getRouteMetadata('/alternatives');

  return (
    <main className="blog-page">
      <section className="blog-hero">
        <div className="container blog-hero-inner">
          <p className="blog-eyebrow">Clientalio Comparisons</p>
          <h1>{metadata.h1}</h1>
          <p>{metadata.description}</p>
        </div>
      </section>

      <section className="blog-content">
        <div className="container blog-content-inner">
          <div className="blog-grid">
            {alternatives.map((alternative) => {
              const alternativeMetadata = getRouteMetadata(alternative.path);

              return (
                <article className="blog-card" key={alternative.slug}>
                  <div className="blog-card-body">
                    <div className="blog-meta"><span>Alternative</span></div>
                    <h2>{alternative.name} Alternative</h2>
                    <p>{alternativeMetadata.description}</p>
                    <Link to={alternative.path} className="blog-read-link">View comparison</Link>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Alternatives;